import { render, staticRenderFns } from "./OwnershipStructure.vue?vue&type=template&id=0221edbe&scoped=true"
import script from "./OwnershipStructure.vue?vue&type=script&lang=js"
export * from "./OwnershipStructure.vue?vue&type=script&lang=js"
import style0 from "./OwnershipStructure.vue?vue&type=style&index=0&id=0221edbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0221edbe",
  null
  
)

export default component.exports